import React from "react";

const AppContainer = ({ className, children, ...rest }) => {
  const lCssClasses = ["mtv-container-app container"];
  if (className) lCssClasses.push(className);
  return <div className={lCssClasses.join(" ")} {...rest}>{children}</div>;
};

export default AppContainer;
